import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-forbidden',
    templateUrl: './forbidden.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './forbidden.component.scss'
})
export class ForbiddenComponent {

}
